import { inject } from '@angular/core';
import { type ActivatedRouteSnapshot, type CanActivateFn, Router } from '@angular/router';
import { PASOS_ONBOARDING, STEPPER_CALCULOS } from '@core/constants/onboarding-steps.constants';
import { OnboardingStepperService } from '@core/services/onboarding-stepper/onboarding-stepper.service';

const PASO_NO_ENCONTRADO = -1;
const INDICE_PRIMER_PASO = 0;

export const onboardingSecuenciaGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const stepperService = inject(OnboardingStepperService);
  const router = inject(Router);

  const slug = route.params['slug'] as string;
  const rutaSolicitada = `/${slug}`;
  const indicePaso = PASOS_ONBOARDING.findIndex((p) => p.ruta === rutaSolicitada);

  if (indicePaso === PASO_NO_ENCONTRADO) return true;
  if (indicePaso === INDICE_PRIMER_PASO) return true;

  const rutaRedireccion = stepperService.obtenerRutaPrimerPasoIncompleto();
  const indicePasoAnterior = indicePaso - STEPPER_CALCULOS.INCREMENTO_PASO;

  if (stepperService.estaPasoCompletado(indicePaso)) return router.createUrlTree([rutaRedireccion]);

  if (!stepperService.estaPasoCompletado(indicePasoAnterior)) return router.createUrlTree([rutaRedireccion]);

  return true;
};
